<header class="flex align-items-center justify-content-between border-bottom px-3 bg-white shadow-1">
    <div class="flex mb-md-0" *ngIf="(user$ | async) && !(hideNavigation$ | async)">
        <app-menu data-auto-id="menuItem" [(visible)]="visible" [promoslotVisible]="false" [navItems]="navItems" [requestServiceEnable]="isRequestServiceEnable"></app-menu>
        <p-button (click)="visible = true" class="p-0" variant="outlined" severity="secondary" rounded data-auto-id="menu-button" ariaLabel="Menu Button">
            <i class="pi pi-bars" aria-hidden="true"></i>
            <span class="hidden md:inline">Menu</span>
        </p-button>
    </div>
    <div class="flex-1 flex justify-content-center mb-md-0" data-auto-id="logo">
        <a href="/" [ngClass]="logoClass$ | async" aria-label="Home"></a>
    </div>
    <div class="border flex gap-2 justify-content-end align-items-baseline" *ngIf="(user$ | async)">
        <div class="flex justify-center">
            <p-button data-auto-id="user-button" (click)="menu.toggle($event)" icon="pi pi-user" [rounded]="true"
                severity="secondary" [outlined]="true" ariaLabel="User menu button"></p-button>
            <p-menu #menu [model]="userMenu" [popup]="true" appendTo="body">
                <ng-template #item let-item>
                    <ng-container *ngIf="item.route; else elseBlock">
                        <a [routerLink]="item.route" routerLinkActive="bg-blue-50" #rla="routerLinkActive"
                            [routerLinkActiveOptions]="{ exact: true }" class="p-menu-item-link p-3" data-auto-id="menuItem">
                            <span class="text-sm" [class.text-blue-600]="rla.isActive"
                                [class.text-slate-500]="!rla.isActive" [class]="item.icon"></span>
                            <span class="ml-2 font-normal font-outfit text-sm" [class.text-blue-600]="rla.isActive"
                                [class.text-slate-800]="!rla.isActive">{{ item.label }}</span>
                        </a>
                    </ng-container>
                    <ng-template #elseBlock>
                        <ng-container *ngIf="item.command; else urlBlock">
                            <a href="#" (click)="item.command()" class="p-menu-item-link p-3" data-auto-id="menuItem">
                                <span class="text-sm" [class]="item.icon"></span>
                                <span
                                    class="ml-2 font-normal font-outfit text-sm text-slate-800"
                                >
                                    {{ item.label }}
                                </span>
                            </a>
                        </ng-container>
                        <ng-template #urlBlock>
                            <a [href]="item.url" class="p-menu-item-link p-3" data-auto-id="menuItem">
                                <span class="text-sm" [class]="item.icon"></span>
                                <span
                                    class="ml-2 font-normal font-outfit text-sm text-slate-800"
                                >
                                    {{ item.label }}
                                </span>
                            </a>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </p-menu>
        </div>
    </div>
</header>
<app-weather-banner *ngIf="(user$ | async)"></app-weather-banner>
<p-message
    *ngIf="paymentBanner?.showBanner"
    styleClass="border-none border-noround py-2 px-3 shadow-2"
    [severity]="paymentBanner?.severity"
    [icon]="paymentBanner?.icon"
    closable
    data-auto-id="main-payment-banner"
    [ariaInjector]="[{
        selector: '.p-message-close-button',
        ariaLabel: 'Payment banner close button',
        role: 'button'
    }]">
    {{paymentBanner?.message}}&nbsp;
    <a 
        *ngIf="paymentBanner?.value === 'pastDuePayment'"
        class="block md:inline md:white-space-nowrap underline cursor-pointer"
        (click)="navigateToPayment()"
        data-auto-id="main-past-due-payment-link"
    >
        Make payment now to avoid gap in coverage
    </a>
</p-message>
<app-ffs-banner *ngIf="isPlanFFS && showFfsBanner"></app-ffs-banner>